// extracted by mini-css-extract-plugin
export default {"input__label":"Input_input__label__ULY+J","input__field":"Input_input__field__uAkn1","input__span":"Input_input__span__Dq+Yr"};